import { render, staticRenderFns } from "./PageModal.vue?vue&type=template&id=ad22f7b8&scoped=true&"
import script from "./PageModal.vue?vue&type=script&lang=js&"
export * from "./PageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad22f7b8",
  null
  
)

export default component.exports